import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import { db } from './main.js'

require('firebase/functions');
require('firebase/firestore');

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentVideo: null,
    selectedCreativeDirection: null,
    nowPlaying: null,
    deliverableCollection: {},
    elementVisibility: {
      "videoFilterForm": false
    },
    selectedClient: null,
    currentUser: null,
    deliverableTransformations: {
      "groupby": "batch",
      "sort":{},
      "filters": []
    },
    currentUserClaims: {},
    users: {},
    clientCollection: {},
    directionCollection: {},
    batchCollection: {},
    fb_adCollection: {}
  },
  mutations: {
    setNowPlaying (state, videoID) {
      state.nowPlaying = videoID;
    },
    setCurrentVideo (state, videoID) {
      state.currentVideo = videoID
    },
    addDeliverableFilter (state, filterData) {
      state.deliverableTransformations.filters.push(filterData)
    },
    removeDeliverableFilter (state, filterID) {
      var newFilters = state.deliverableTransformations.filters.filter((filterElem)=>{
        (filterElem.id != filterID)
      })
      state.deliverableTransformations.filters = newFilters
    },
    updateDeliverableTransform (state, transformObj) {
      state.deliverableTransformations = transformObj;
    },
    updateDeliverableGroupBy (state, groupByValue) {
      state.deliverableTransformations.groupby = groupByValue;
    },
    updateVideos (state, videoData) {
      state.deliverableCollection = videoData
    },
    updateAds (state, adData) {
      state.fb_adCollection = adData
    },
    updateUserList (state, userData) {
      state.users = userData
    },
    updateClients (state, clientData) {
      state.clientCollection = clientData
    },
    changeSelectedClient (state, clientID) {
      state.selectedClient = clientID
    },
    setCurrentUser (state, userObj) {
      state.currentUser = userObj
    },
    setCurrentUserClaims (state, claimObj) {
      state.currentUserClaims = claimObj
    },
    setCreativeDirections (state, creativeDirections) {
      state.directionCollection = creativeDirections
    },
    setDeliveryBatches (state, deliveryBatches) {
      state.batchCollection = deliveryBatches
    },
    checkSelectedClient (state) {
      if (!state.selectedClient) {
        var firstClientID = Object.keys(state.clientCollection)[0]
        state.selectedClient = firstClientID
      }
    },
    toggleVisibility (state, elementName) {
      state.elementVisibility[elementName] = !state.elementVisibility[elementName]
    }
  },
  actions: {
    preflightChecks (context) {
      return new Promise(async (resolve) => {
        if (Object.keys(context.state.clientCollection).length < 1) {
          await context.dispatch("fireFetchAvailableClients")
        }
        if (!context.state.selectedClient) {
          context.commit("checkSelectedClient")
        }
        resolve()
      })
    },
    checkUser (context) {
      return new Promise((resolve) => {
        firebase.auth().onAuthStateChanged( (user) => {
          if (user) {
            context.commit("setCurrentUser",user.uid)
            user.getIdTokenResult().then((idTokenResult)=>
            {
              context.commit("setCurrentUserClaims",idTokenResult.claims)
              resolve("resolve")
            })
          } else {
            context.commit("setCurrentUser",null)
            context.commit("setCurrentUserClaims",{})
            resolve("resolve")
          }
        })
      })
    },
    updateFirebaseRecord (context, updatePayload) {
      var updateDoc = updatePayload[0]
      var updateFields = updatePayload[1]
      return new Promise((resolve,reject) => {
        updateDoc.set(updateFields, { merge: true }).then(
          (result)=>{
            resolve(result)
          },(error)=>{
            reject(error)
            console.log(error)
          }
        )
      })

    },
    fetchDeliveryBatches (context){
      const clientDoc = db.doc("/clients/" + context.state.selectedClient);
      db.collection("batches").where("client", "==", clientDoc)
      .onSnapshot(function(querySnapshot) {
        var batches = {}
        querySnapshot.forEach((doc)=>{
          batches[doc.id] = doc.data()
          batches[doc.id].ref = doc.ref
        })
        context.commit('setDeliveryBatches',batches)
      })
    },
    fireFetchAvailableClients (context){
      return new Promise((resolve) => {
        var query
        if (context.getters.isAdmin) {
          query = db.collection("clients").where("active", "==", true)
        } else {
          var permittedClients = context.state.currentUserClaims.projects
          query = db.collection("clients").where(firebase.firestore.FieldPath.documentId(), "in", permittedClients).where("active", "==", true)
        }
        query
        .onSnapshot(function(querySnapshot) {
          var clients = {};
          querySnapshot.forEach(function(doc) {
            clients[doc.id] = doc.data()
            clients[doc.id].ref = doc.ref
            clients[doc.id].id = doc.id
          });
          context.commit('updateClients',clients)
          resolve("updated")
        });
      })
    },
    fireFetchCreativeDirections (context) {
      return new Promise((resolve) => {
        const clientDoc = db.doc("/clients/" + context.state.selectedClient);
        db.collection("directions").where("client", "==", clientDoc)
        .onSnapshot(function(querySnapshot) {
          var directions = {}
          querySnapshot.forEach(function(doc) {
            var directionData = doc.data()
            var currentClientAbbreviation = context.state.selectedClient
            directions[doc.id] = {
              ...doc.data(),
              displayName: currentClientAbbreviation + directionData.number + ": " + directionData.name,
              code: currentClientAbbreviation + directionData.number,
              ref: doc.ref
            }
          });
          context.commit('setCreativeDirections',directions)
          resolve("updated")
        });

      })
    },
    async fireFetchVideos (context) {
      var clientAbbreviation = context.state.selectedClient
      //console.log(clientAbbreviation);
      const clientDoc = db.doc("/clients/" + clientAbbreviation);
      //console.log("fetching creative directions");
      await context.dispatch("fireFetchCreativeDirections")
      //console.log("fetching delivery batches");
      await context.dispatch("fetchDeliveryBatches")
      //console.log("finsihed");
      db.collection("deliverables").where("client", "==", clientDoc)
      .onSnapshot(function(querySnapshot) {
        var creativeDirections = context.state.directionCollection
        var videos = {}
        querySnapshot.forEach(function(doc) {
          var video = doc.data()
          var directionNumber
          if (video.direction && creativeDirections[video.direction.id].number) {
            directionNumber = creativeDirections[video.direction.id].number
          }
          var deliveryCode = doc.data().direction && video.number && directionNumber ? `${clientAbbreviation}${directionNumber}-${video.number}`: ""
          videos[doc.id] = {
            ...doc.data(),
            id: doc.id,
            ref: doc.ref,
            deliveryCode: deliveryCode,
            name:  deliveryCode
          }
        });
        context.commit('updateVideos',videos);
      });
    },
    fetchAds (context) {
      var ads = {}
      var clientAbbreviation = context.state.selectedClient
      const clientDoc = db.doc("/clients/" + clientAbbreviation);
      db.collection("fb_ads").where("client", "==", clientDoc).where('archived', '==', false)
      .onSnapshot(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          ads[doc.id] = {
            ...doc.data(),
            id: doc.id,
            ref: doc.ref
          }
        })
        context.commit('updateAds',ads)
      })
    },
    getCurrentUser (context) {
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          context.commit('setCurrentUser',user.uid)
          user.getIdTokenResult().then((token) => {
            //console.log(token.claims)
            context.commit('setCurrentUserClaims',token.claims)
          })
        }
      });
    },
    fetchVideos () {
      //var selectedClientDetails = context.state.clientCollection[context.state.selectedClient]
      //var fetchVideosCloudFunction = firebase.functions().httpsCallable('fetchVideos');
      //console.log(selectedClientDetails)
      //console.log({frameProjectID: selectedClientDetails.frameProjectID, airtableID: context.state.selectedClient})
      //fetchVideosCloudFunction({frameProjectID: selectedClientDetails.frameProjectID, airtableID: context.state.selectedClient}).then(function(result) {
      //  context.commit('updateVideos',result.data);
      //});
    },
    fetchAllUsers (context) {
      var fetchAllUsersCloudFunction = firebase.functions().httpsCallable('fetchAllUsers');
      fetchAllUsersCloudFunction().then(function(result){
        context.commit('updateUserList',result.data.users)
      }).catch(function(error){
        console.log(error)
      })
    },
    fetchAvailableClients (context, userid) {
      var fetchClientsCloudFunction = firebase.functions().httpsCallable('fetchAvailableClients');
      fetchClientsCloudFunction({uid: userid}).then(function(){
        //context.commit('updateClients',result.data)
        //context.dispatch('checkDefaultClient')
      }).catch(function(error){
        console.log(error);
      })
    },
    makeAdmin (context, userid) {
      var makeAdminCloudFunction = firebase.functions().httpsCallable('makeUserAdmin');
      makeAdminCloudFunction({uid: userid}).then(function(){
        context.dispatch('fetchAllUsers')
      }).catch(function(error){
        console.log(error);
      })
    },
    removeAdmin (context, userid) {
      var removeAdminCloudFunction = firebase.functions().httpsCallable('removeUserAdmin');
      removeAdminCloudFunction({uid: userid}).then(function(){
        context.dispatch('fetchAllUsers')
      }).catch(function(error){
        console.log(error);
      })
    },
    addProjectToUser (context, payload) {
      var addProjectToUserCloudFunction = firebase.functions().httpsCallable('addProjectToUser');
      addProjectToUserCloudFunction(payload).then(function(){
        context.dispatch('fetchAllUsers')
      }).catch(function(error){
        console.log(error)
      })
    },
    removeProjectFromUser (context, payload) {
      var removeProjectFromUserCloudFunction = firebase.functions().httpsCallable('removeProjectFromUser');
      removeProjectFromUserCloudFunction(payload).then(function(){
        context.dispatch('fetchAllUsers')
      }).catch(function(error){
        console.log(error)
      })
    },
    updateBatchInfo (context, updatePayload) {
      var batchRef = updatePayload[0]
      var updateObject = updatePayload[1]
      return new Promise((resolve) => {
        batchRef.set(updateObject, { merge: true }).then(()=>{
          resolve("updated")
        })
      })
    },
    updateDeliverableInfo (context, updatePayload) {
      var deliverableRef = updatePayload[0]
      var updateObject = updatePayload[1]
      return new Promise((resolve) => {
        deliverableRef.set(updateObject, { merge: true }).then(()=>{
          resolve("updated")
        })
      })
    },
    createDeliverable (context, clientRef) {
      db.collection("deliverables").add({
        client: clientRef
      })
    },
    createNewBatch (context) {
      db.collection("batches").add({
        name: "Untitled Batch",
        deliveryDate: new Date(),
        client: context.state.clientCollection[context.state.selectedClient].ref,

      })
    },
    updateBatchMembership (context, updatePayload) {
      var batchRef = updatePayload[0]
      var videoList = updatePayload[1]
      var videoPosition = 0;
      videoList.forEach((video)=>{
        video.ref.update({
          batchRank: videoPosition,
          batch: batchRef
        })
        videoPosition++
      })
    },
    createNewDirection (context) {
      db.collection("directions").add({
        name: "Untitled Direction",
        client: context.state.clientCollection[context.state.selectedClient].ref,

      })
    },
    deleteBatch (context, batchRef) {
      batchRef.delete()
    },
    deleteFirebaseRecord (context, record) {
      record.delete()
    },
    logoutReset (context) {
      context.commit("setCurrentUser",null)
      context.commit("setCurrentUserClaims",{})
      context.commit("setDeliveryBatches",{})
      context.commit("setCreativeDirections",{})
      context.commit("updateVideos",{})
      context.commit("updateUserList",[])
      context.commit("updateClients",{})
    }
  },
  getters: {
    videoFilterList(state) {
      var filterList = []

      state.deliverableTransformations.filters.forEach((filter)=>{
        var filterInfo = {}
        if (filter.fieldType === "reference") {
          var referencedElem = state[`${filter.field}Collection`][filter.value]
          filterInfo = {
            name: referencedElem.displayName ? referencedElem.displayName : referencedElem.name,
            ...filter
          }
        }
        filterList.push(filterInfo)
      })
      return filterList
    },
    directionArray (state) {
      var directionArray = []
      Object.keys(state.directionCollection).forEach((directionID)=>{
        var directionData = {id:directionID,...state.directionCollection[directionID]}
        directionArray.push(directionData)
      })
      directionArray.sort((a, b) => (a.number < b.number) ? 1 : -1)
      return directionArray
    },
    batchArray (state) {
      var batchArray = []
      Object.keys(state.batchCollection).forEach((batchID)=>{
        batchArray.push({
          id:batchID,
          ...state.batchCollection[batchID]
        })
      })
      batchArray.sort((a, b) => {
        if (a.deliveryDate && b.deliveryDate) {
          return (a.deliveryDate.seconds < b.deliveryDate.seconds) ? 1 : -1
        } else {
          return -1
        }

      })
      return batchArray
    },
    deliverableArray (state, getters) {
      var allDeliverables = []
      var sortedDeliverables = []
      Object.keys(state.deliverableCollection).forEach((deliverableID)=>{
        var deliverableData = state.deliverableCollection[deliverableID]
        if (deliverableData.number && deliverableData.direction) {
            var directionName = state.directionCollection[deliverableData.direction.id].name
            var displayName = `${deliverableData.deliveryCode}: ${directionName} ${deliverableData.number}`
          allDeliverables.push({
            id: deliverableID,
            displayName: displayName,
            ...deliverableData
          })
        }
      })
      getters.directionArray.forEach((direction) => {
        var matchingDeliverables = allDeliverables.filter((deliverable)=>{
          if (deliverable.direction && deliverable.direction.id === direction.id) {
            return true
          } else {
            return false
          }
        })
        matchingDeliverables.sort((a,b)=>(a.number > b.number) ? -1 : 1)
        //console.log(matchingDeliverables);
        sortedDeliverables.push(...matchingDeliverables)
      })
      return sortedDeliverables
    },
    clientArray (state) {
      var clientArray = []
      Object.keys(state.clientCollection).forEach((clientID)=>{
        clientArray.push({id: clientID,...state.clientCollection[clientID]})
      })
      //console.log(clientArray);
      return clientArray
    },
    getSelectedClient (state) {
      return state.selectedClient
    },
    getVideosWithoutBatch (state) {
      var allVideoArray = []
      Object.keys(state.deliverableCollection).forEach((deliverableID)=>{
        allVideoArray.push(state.deliverableCollection[deliverableID])
      })
      var filteredVideos = allVideoArray.filter((video)=>{
        if (!video.batch) {
          return true
        } else {
          return false
        }
      })
      var sortObj = state.deliverableTransformations.sort
      var firstSortValue = sortObj.direction
      var secondSortValue = firstSortValue === 1 ? -1 : 1
      filteredVideos.sort((a, b) => (a[sortObj.field] > b[sortObj.field]) ? firstSortValue : secondSortValue)
      return filteredVideos
    },
    getUnarchivedAds(state) {
      var allAdArray = []
      Object.keys(state.fb_adCollection).forEach((adID)=>{
        allAdArray.push(state.fb_adCollection[adID])
      })
      return allAdArray
    },
    getFilteredVideos (state, getters) {
      var videoGroupArray = []
      var videoArray = []

      Object.keys(state.deliverableCollection).forEach((value)=>{
        videoArray.push(state.deliverableCollection[value])
      })
      //Filter videos
      var filteredVideoArray = videoArray.filter((video)=>{
        var firstFilter = state.deliverableTransformations.filters[0]
        if (firstFilter) {
          var filterField = firstFilter.field
          if (firstFilter.fieldType === "reference") {
            if (video[filterField]) {
              return (video[filterField].id === firstFilter.value)
            } else {
              return false
            }

          } else {
            return true
          }
        } else {
          return true
        }
      })

      //Group and sort videos
      var groupByCollection = state.deliverableTransformations.groupby
      getters[groupByCollection + "Array"].forEach((collectionElem) => {
        var collectionElemVideos = filteredVideoArray.filter((video) => {
          if (video[groupByCollection]) {
            return video[groupByCollection].id === collectionElem.id
          } else {
            return false
          }
        })
        //Sort videos
        if (state.deliverableTransformations.sort) {
          var sortObj = state.deliverableTransformations.sort
          var firstSortValue = sortObj.direction
          var secondSortValue = firstSortValue === 1 ? -1 : 1
          collectionElemVideos.sort((a, b) => (a[sortObj.field] > b[sortObj.field]) ? firstSortValue : secondSortValue)
        }
        videoGroupArray.push({
          name: collectionElem.displayName ? collectionElem.displayName : collectionElem.name,
          ref: collectionElem.ref,
          id: collectionElem.id,
          videos: collectionElemVideos
        })
      })
      return videoGroupArray;
    },
    currentUser (state) {
      return state.currentUser;
    },
    isAdmin (state) {
      if (state.currentUserClaims) {
        if (state.currentUserClaims.admin) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }

    }
  }
})
